// Render an 8-digit auth/login code in the 4-4 display format (e.g. "12345678"
// -> "1234-5678"), matching the dashed format the login inputs use. Returns the
// raw value unchanged if it isn't exactly 8 digits.
export default function formatAuthCode(code) {
  const digits = String(code || "").replace(/\D/g, "")
  if (digits.length !== 8) return code || ""
  return [digits.slice(0, 4), digits.slice(4)].join("-")
}
